const campusLegacy = [
  {
    title: "About the CEC Campus",
    link: "/about-cec",
  },
  {
    title: "History of CEC",
    link: "/history-of-cec",
  },
  {
    title: "Glimpses of CEC",
    link: "/glimpses-of-cec",
  },
];

const administration = [
  {
    title: "Our Founder",
    link: "/our-founder",
  },
  {
    title: "Our Management",
    link: "/our-management",
  },
  {
    title: "Governing Council",
    link: "/governing-council",
  },
  {
    title: "Key Functionaries & HODs",
    link: "/key-functionaries-and-hods",
  },
  {
    title: "Educators & Administrators",
    link: "/educators-administrators",
  },
  {
    title: "Distinctive & Practices",
    link: "/distinctive-practices",
  },
];
const accreditations = [
  {
    title: "Mandatory Disclosure",
    link: "/mandatory-disclosure",
  },
];
const studentSupport = [
  {
    title: "Grievance Redressal Cell",
    link: "/grievance-redressal-cell",
  },
  {
    title: "Student Welfare Department",
    link: "/student-welfare-department",
  },
];

const departments = [
   {
    title: "Artificial Intelligence and Data Science",
    link: "/department/artificial-intelligence-data-science",
  },
  {
    title: "Artificial Intelligence and Machine Learning",
    link: "/department/artificial-intelligence-machine-learning",
  },
  {
    title: "Computer Science and Business System",
    link: "/department/computer-science-business-system",
  },
  {
    title: "Computer Science and Design",
    link: "/department/computer-science-design",
  },
  {
    title: "Computer Science and Engineering",
    link: "/department/computer-science-engineering",
  },
  {
    title: "Electronics and Communication Engineering",
    link: "/department/electronics-communication-engineering",
  },
  {
    title: "Information Science and Engineering",
    link: "/department/information-science-engineering",
  },
  {
    title: "Mechanical Engineering",
    link: "/department/mechanical-engineering",
  },
  {
    title: "Science and Humanities",
    link: "/department/science-humanities",
  },
];

const pgDepartments = [
  {
    title: "MBA (FinTech and Data Science)",
    link: "/department/mba",
  },
  {
    title: "MCA (Full Stack Development, AI and ML)",
    link: "/department/mca",
  },
  
];

const curriculum = [
  // {
  //   title: "Academic Overview",
  //   link: "/academic-overview",
  // },
  // {
  //   title: "Programs",
  //   link: "/programs",
  // },
  {
    title: "Academic Council",
    link: "/academic-council",
  },
 
  {
    title: "Scheme",
    link: "/autonomous-scheme",
  },
  {
    title: "Syllabus",
    link: "/autonomous-syllabus",
  },
];

const alumni = [
  {
    title: "Alumni",
    link: "/alumni",
  },
];

const campusBeats = [
  // {
  //   title: "Calendar of Events",
  //   link: "/events",
  // },

  {
    title: "Student Achievements",
    link: "/student-achievements",
  },
  {
    title: "Student Life & Engagement",
    link: "/studentlife-engagement",
  },
  {
    title: "Campus Buzz",
    link: "/campus-buzz",
  },
];

const learningHub = [
  {
    title: "Resources",
    link: "https://digital.canaraengineering.in/",
  },
  {
    title: "Research at CEC",
    link: "/research",
  },
];

const campusFacilities = [
  {
    title: "Infrastructure",
    link: "/infrastructure",
  },
  {
    title: "Hostel Life",
    link: "/hostel-life",
  },
  {
    title: "Central Library",
    link: "/central-library",
  },
  {
    title: "Physical Education",
    link: "/physical-education",
  },
];

const studentLife = [
  {
    title: "Cultural Activities",
    link: "/culturalActivities",
  },
  {
    title: "Technical Activities",
    link: "/HostelLife",
  },
  {
    title: "NSS",
    link: "/HostelLife",
  },
];

const innovation = [
  {
    title: "Entrepreneurship Cell",
    link: "/entrepreneurship-cell",
  },
  {
    title: "Cif",
    link: "/cif",
  },
];

const examination = [
  // {
  //   title: "Examination Timetables",
  //   link: "/examination-records?tab=tt",
  // },
  {
    title: "Circulars",
    link: "/examination-records?tab=circulars",
  },
  
  {
    title: "Student Dashboard",
    link: "https://cecstudent.canaraengineering.in",
  },
];
export {
  campusFacilities, //
  studentSupport, //
  examination, //
  campusLegacy, //
  administration, //
  learningHub, //
  accreditations, //
  curriculum, //
  departments, //
  studentLife, //
  innovation, //
  campusBeats, //
  alumni,
  pgDepartments,
};
